import { ref } from "vue";
import type { MaybeRef } from "@/typings/refs";
import type { Ref } from "vue";
/**
 * @function useSetter - composable function to set a value,
 * works on any type of value, if ypu need to toggle a boolean useToggle works better
 * @param {MaybeRef<ValueType>} initialValue - a maybe ref value to modify, defines the type for typechecking, give either a ref or a value of that type
 * @return the toggler function, and a value
 */
export default function useSetter<ValueType>(
  initialValue?: MaybeRef<ValueType>
): {
  setter: (targetValue: ValueType) => void;
  value: Ref<ValueType>;
} {
  /** value to toggle, if obtained as parameter change that, if a new value */
  const value: Ref<ValueType> = ref(initialValue) as Ref<ValueType>;
  /** function that toggles the flag*/
  const setter = (targetValue: ValueType) => {
    value.value = targetValue;
  };

  return { value, setter };
}
